(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var productJson = root.querySelector('[data-product-json]');
    if (!productJson) return;
    var product = JSON.parse(productJson.textContent);
    var variantInput = root.querySelector('[data-product-form-variant-id]');
    var selected = {};

    root.querySelectorAll('.at-product-option').forEach(function (fieldset) {
      var position = fieldset.getAttribute('data-option-position');
      var pressed = fieldset.querySelector('[aria-pressed="true"]');
      if (pressed) {
        selected[position] = pressed.getAttribute('data-option-value');
      }
    });

    function findVariant() {
      return product.variants.find(function (variant) {
        return Object.keys(selected).every(function (index) {
          return variant.options[index] === selected[index];
        });
      });
    }

    function updateSubmit(variant) {
      var submitButton = root.querySelector('[data-buy-buttons-submit]');
      var label = root.querySelector('[data-buy-buttons-label]');
      if (!variant) return;
      variantInput.value = variant.id;
      if (submitButton) {
        submitButton.disabled = !variant.available;
      }
      if (label) {
        label.textContent = variant.available ? label.dataset.available || label.textContent : label.dataset.soldOut || label.textContent;
      }
    }

    var quantityInput = root.querySelector('[data-quantity-input]');
    var decreaseBtn = root.querySelector('[data-quantity-decrease]');
    var increaseBtn = root.querySelector('[data-quantity-increase]');
    if (quantityInput && decreaseBtn && increaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var value = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = Math.max(1, value - 1);
      });
      increaseBtn.addEventListener('click', function () {
        var value = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = value + 1;
      });
    }

    root.querySelectorAll('.at-product-option').forEach(function (fieldset) {
      var position = fieldset.getAttribute('data-option-position');
      fieldset.querySelectorAll('[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          fieldset.querySelectorAll('[data-option-value]').forEach(function (sibling) {
            sibling.setAttribute('aria-pressed', 'false');
          });
          button.setAttribute('aria-pressed', 'true');
          selected[position] = button.getAttribute('data-option-value');
          var variant = findVariant();
          if (variant) {
            updateSubmit(variant);
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
        });
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-media-toggle]');
    if (!toggle) return;
    const video = toggle.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
      toggle.classList.add('is-playing');
    } else {
      video.pause();
      toggle.classList.remove('is-playing');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
